module.exports = __webpack_public_path__ + "static/media/1-1.71b4dc8b.png";